window.addEventListener('DOMContentLoaded', () => {
	const header = document.querySelector('header')
	const hamburger = document.querySelector('header .hamburger')
	let previousScrollTop = 0

	// Market Conditions
	const marketConditions = document.querySelector('header .market-conditions')
	const mconStatus = marketConditions?.querySelector('.status')
	const mconDetail = marketConditions?.querySelector('.detail .content')

	window.addEventListener('scroll', e => {
		let currentScrollTop = window.scrollY

		if (previousScrollTop - currentScrollTop < 0 && currentScrollTop > 150) {
			header.classList.add('scrolled-down')
			hamburger.classList.remove('open')
			marketConditions?.classList.remove('open')
		} else {
			header.classList.remove('scrolled-down')
		}

		if (currentScrollTop > 50) {
			header.classList.add('add-bg-color')
		} else {
			header.classList.remove('add-bg-color')
		}

		previousScrollTop = currentScrollTop
	})

	hamburger.addEventListener('click', e => {
		hamburger.classList.toggle('open')
	})

	window.addEventListener('click', e => {
		if (
			e.target.tagName != 'A' &&
			!e.target.closest('.hamburger') &&
			!e.target.closest('.market-conditions')
		) {
			hamburger.classList.remove('open')
		}
	})

	if (mconDetail) {
		marketConditions.setAttribute('style', `--open-height: auto;`)
		marketConditions.setAttribute(
			'style',
			`--open-height: ${mconDetail.scrollHeight}px;`
		)

		mconStatus.addEventListener('click', () => {
			marketConditions.classList.toggle('open')
		})

		window.addEventListener('resize', () => {
			marketConditions.setAttribute('style', `--open-height: auto;`)
			marketConditions.setAttribute(
				'style',
				`--open-height: ${mconDetail.scrollHeight}px;`
			)
		})

		window.addEventListener('click', e => {
			if (!e.target.closest('.market-conditions')) {
				marketConditions.classList.remove('open')
			}
		})

		window.addEventListener('touchstart', e => {
			if (!e.target.closest('.market-conditions')) {
				marketConditions.classList.remove('open')
			}
		})
	}
})
